module.exports = __webpack_public_path__ + "img/big-heart.802f0588.png";